<template>
  <VContainer fluid class="transparent ma-0 pa-0" style="background: #3D4A6D;">
    <VContainer fluid class="transparent secondary ma-0 pa-0">
      <!-- DESKTOP -->
      <VRow class="d-none d-lg-block gradient-plan ma-0 pa-0 mt-n1" style="width: 100%; position: relative; background: #DFDFDD;">
        <VCol cols="12">
          <div class="text-h2 font-weight-black text-primary">
            {{ $t('MENU.subscription') }}
          </div>
        </VCol>

        <VCol cols="12">
          <VRow>
            <VCol cols="auto">
              <div class="text-h3 text-warning font-weight-black">
                {{ $t('PLAN.monthly') }}
              </div>
            </VCol>

            <VCol cols="auto">
              <VSwitch
                class="mb-4"
                v-model="timeSwitcher"
                hide-details
                color="secondary"
              />
            </VCol>

            <VCol cols="auto">
              <div class="text-h3 text-warning font-weight-black">
                {{ $t('PLAN.anual') }}
              </div>
            </VCol>
          </VRow>
        </VCol>
      </VRow>

      <!-- MOBILE -->
      <VRow class="d-md-none" style="position: relative;">
        <VCol cols="12">
          <div class="text-h4 mt-n4 font-weight-black text-primary">
            {{ $t('MENU.subscription') }}
          </div>
        </VCol>
        <VCol cols="12">
          <div class="text-h5 mt-n6 text-warning font-weight-black">
            {{ $t('PLAN.monthly') }}
          </div>
        </VCol>
      </VRow>

      <!-- Cards Mensal -->
      <VCard
        class="d-flex justify-center mt-4"
        color="transparent"
        variant="text"
        v-if="!timeSwitcher"
      >
        <VRow>
          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                title="Golden"
                price="250€"
                :diskInformation="$t('PLAN.disk4')"
                :targetTo="$t('PLAN.to10')"
              />
            </VCard>
          </VCol>

          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                :focus="true"
                figure="diamond"
                :diskInformation="$t('PLAN.disk10')"
                title="Diamond"
                price="350€"
                :targetTo="$t('PLAN.to50')"
              />
            </VCard>
          </VCol>

          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                title="Tailored"
                figure="hexagon"
                :price="$t('PLAN.tailored_price')"
                :targetTo="$t('PLAN.tailored')"
              />
            </VCard>
          </VCol>
        </VRow>
      </VCard>

      <!-- Cards Anual -->
      <VCard
        class="d-flex justify-center mb-6"
        color="transparent"
        variant="text"
        v-else
      >
        <VRow>
          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                title="Golden"
                price="2500€"
                :diskInformation="$t('PLAN.disk4')"
                :priceReduction="$t('PLAN.EARLY')"
                :targetTo="$t('PLAN.to10')"
              />
            </VCard>
          </VCol>

          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                :focus="true"
                figure="diamond"
                :diskInformation="$t('PLAN.disk10')"
                title="Diamond"
                price="3500€"
                :priceReduction="$t('PLAN.EARLY')"
                :targetTo="$t('PLAN.to50')"
              />
            </VCard>
          </VCol>

          <VCol cols="12" md="4">
            <VCard color="transparent" variant="text">
              <PlanCard
                title="Tailored"
                figure="hexagon"
                :price="$t('PLAN.tailored_price')"
                :targetTo="$t('PLAN.tailored')"
              />
            </VCard>
          </VCol>
        </VRow>
      </VCard>
    </VContainer>
  </VContainer>
</template>

<script>
import PlanCard from '@/components/ui/PlanCard.vue'

export default {
  name: 'SubscriptionPlan',
  components: { PlanCard },
  data() {
    return {
      timeSwitcher: false
    }
  }
}
</script>

<style>
@media (min-width: 850px) {
  .gradient-plan {
    clip-path: polygon(0 0, 100% 0, 100% 3%, 0% 100%);
  }
}

body .linear-background {
  clip-path: polygon(0 0, 100% 0, 100% 97%, 0% 100%);
}

@media (min-width: 850px) {
  body .linear-background {
    clip-path: polygon(0 0, 100% 0, 100% 90%, 0% 100%);
  }
}
</style>
